import { EMAIL_VIEW_ERROR, EMAIL_VIEW_POST_ERROR,EMAIL_VIEW_SUCCESS , EMAIL_EDIT_SUCCESS, EMAIL_EDIT_ERROR} from "../actions/types";

export default (state = {  
    error: null,
    results:[],
    success:false,
}, action) => {
    switch (action.type) {
    case EMAIL_VIEW_SUCCESS:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: false,
        loading: false,
        error:false,
        ErrorMessage: 'Retrieve Success',
        success:true,
        results: action.payload
        }; 
        case EMAIL_EDIT_SUCCESS:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: false,
        loading: false,
        error:false, 
        success:true,
        ErrorMessage: 'Edit Success | ' + action.payload,
        }; 
        
        case EMAIL_EDIT_ERROR:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: false,
        loading: false,
        error:false,
        ErrorMessage: action.payload,
        success:true
        }; 
      case EMAIL_VIEW_POST_ERROR:
        return {
            ...state, 
            error: state.error,
            loading:false,
            success: false,
            isSnackbarError: true,
            isSwitchSnackbarOn: true,
            ErrorMessage: "EMAIL POST ERROR | CONTACT NETWORK ADMINISTRATOR",
        }
        break; 
    case EMAIL_VIEW_ERROR:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: true,
        loading: false,
        ErrorMessage: action.payload,
        error:true,
        success:false
        };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/emailReducer.js